/**
 * <code>Animation2DEvent</code> 类用于实现动画事件。
 */
export class Animation2DEvent {
    /** 事件触发时间。*/
    time: number;
    /** 事件触发名称。*/
    eventName: string;
    /** 事件触发参数。*/
    params: any[];

    /**
     * 创建一个 <code>Animation2DEvent</code> 实例。
     */
    constructor() {
    }

}
